export default __webpack_public_path__ + "static/media/body-core.e953d978.png";